export default {
  name: 'WeSpLeft',
  props: {
    treeData: Array,
    deptIds: Array,
    //通过可选范围的ids处理组织机构，成员接口参数，当deptIds仅仅是本部门人员时，常用组群，个人组群不可点击
    tabData: {
      type: Array,
      default: () => [{
        id: '0',
        name: '组织机构'
      }]
    },
    currentTreeNode: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      expandedKeys: [],
      currentNodekey: '',
      activeTab: "",
      filterText: ""
    };
  },

  computed: {
    innerTreeData() {
      return this.treeData;
    },

    showCurrentDept() {
      let flag = false;
      let ids = ["2", "xld"];
      if (!this.deptIds) return;

      switch (this.deptIds.length) {
        case 1:
          flag = ids.includes(this.deptIds[0]) ? true : false;
          break;

        case 2:
          flag = this.deptIds.includes("2") && this.deptIds.includes("xld") ? true : false;
          break;
      }

      return flag;
    }

  },
  watch: {
    activeTab(val) {
      let activeItem = this.tabData.find(el => el.id === val);
      this.$emit("change-tab", val, activeItem);
    },

    innerTreeData: {
      handler: function (val) {
        if (val.length > 0) {
          this.$nextTick(() => {
            this.currentNodekey = this.currentTreeNode && this.currentTreeNode.id;
            let ref = this.$refs[`tree_${this.activeTab}`][0];
            ref.setCurrentKey(this.currentNodekey); //一定要加这个选中了否则样式没有出来
          });
        }
      },
      deep: true
    }
  },
  methods: {
    handlerTabChange() {
      this.tabData.forEach(el => {
        if (el.id === this.activeTab) this.$set(el, "filterText", "");
      });
    },

    handlerCheckChangeTreeNode(data) {
      data._checked = true;
      this.$emit("on-select", data);
    },

    // 抛出到父级去查询树节点对应的人员的数据
    treeItemSelect(data) {
      this.$emit('on-select', data);
    }

  }
};